import React, { useEffect, useRef, useState } from "react";
//dropdown
import sortIcon from "../../assets/LogsListAssets/sortIcon.svg";
import { IoIosArrowDown } from "react-icons/io";

const TasksListDropdown = () => {
  const dropdownRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Clicked outside the dropdown, so close it
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    // Attach the event listener when the component mounts
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex gap-2">
      <div className="font-medium relative text-sm group">
        <img src={sortIcon} alt="profile" className="cursor-pointer" />
        <div className="bg-white absolute border border-lite-grey-4 invisible group-hover:visible right-0 rounded-lg z-20 mt-[3px]">
          <ul className="z-10 bg-white max-h-[200px] overflow-y-auto rounded-lg w-40">
            <li className="sort-list-items">Newest First</li>
            <li className="sort-list-items">Oldest First</li>
            <li className="sort-list-items">Last Modified</li>
            <li className="sort-list-items">Created On</li>
          </ul>
        </div>
      </div>

      <div
        className="font-medium relative cursor-pointer w-40"
        ref={dropdownRef}
      >
        <div
          className="text-sm px-2 py-1 text-center text-black flex items-center justify-between rounded-md border border-[#C7C7C7]"
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <span className="overflow-hidden whitespace-nowrap text-ellipsis">
            All Tasks
          </span>
          <IoIosArrowDown />
        </div>
        <div
          className={`bg-white absolute border border-lite-grey-4 right-0 rounded-md z-20 mt-[3px] ${
            dropdownOpen ? "block" : "hidden"
          }`}
        >
          <ul className="z-10 bg-white max-h-[200px] overflow-y-auto rounded-lg w-40">
            <li className="sort-list-items">All Tasks</li>
            <li className="sort-list-items">Completed Tasks</li>
            <li className="sort-list-items">Failed Tasks</li>
            <li className="sort-list-items">Click stream</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TasksListDropdown;
